import { useEffect, useState } from 'react';
/**
 * useSSR
 * - Hook providing a check for server-side or client-side rendering
 * @param {boolean} initialIsBrowser optional initialState, defaults to false.
 * @returns `isBrowser` if there is a window global present, and `isServer` as the opposite for semantic convenience
 */
export const useSSR = (initialIsBrowser = false) => {
    const [isBrowser, setIsBrowser] = useState(initialIsBrowser);
    const isServer = !isBrowser;
    useEffect(() => {
        setIsBrowser(true);
    }, []);
    return { isBrowser, isServer };
};
